<div class="table-scroll-container">
  <table
    class="schedules-table"
    [ngClass]="{ 'embedded-view-table': embeddedView, 'hour-header-table': showHourHeader }"
  >
    <colgroup>
      @if (!this.embeddedView) {
        <col class="keyboard-arrow-col-width" />
      }
      <col class="date-col-width" />
      <col class="rest-hours-col-width" />
      <col class="rest-days-col-width" />
      @for (halfHourInADay of halfHoursInADay; track halfHourInADay) {
        <col class="time-col-width" />
      }
    </colgroup>
    <thead>
      <tr>
        @if (!this.embeddedView) {
          <th class="keyboard-arrow-col"></th>
        }
        <th class="fixed-col date-col">{{ 'date' | translate | uppercase }}</th>
        <th class="fixed-col rest-hours-col padded">
          {{ 'restIn24Hours' | translate | uppercase }}
        </th>
        <th class="fixed-col rest-days-col">{{ 'restIn7Days' | translate | uppercase }}</th>
        @if (showHourHeader) {
          @for (hourHeaderLabel of hourHeaderLabels; track hourHeaderLabel) {
            <th class="header-grid-cell header-hour-cell" colspan="2">
              {{ hourHeaderLabel }}
            </th>
          }
        } @else {
          @for (
            halfHourInADay of halfHoursInADay;
            track halfHourInADay;
            let competenceIndex = $index
          ) {
            <th
              class="header-grid-cell"
              [ngClass]="{
                'colored-background': !embeddedView && competenceIndex % 2 === 0,
              }"
            >
              @if (!embeddedView) {
                {{ hoursInADay[competenceIndex] }}
              }
            </th>
          }
        }
      </tr>
    </thead>
    <tbody>
      @for (daySchedule of daySchedules; track daySchedule) {
        <tr
          (click)="onRowClick(daySchedule)"
          [ngClass]="{
            'expandable-row': daySchedule.additionalInformation?.length,
          }"
        >
          @if (!this.embeddedView) {
            <td class="keyboard-arrow-cell">
              @if (daySchedule.additionalInformation?.length) {
                @if (!daySchedule.showDetails) {
                  <mat-icon>keyboard_arrow_down</mat-icon>
                }
                @if (daySchedule.showDetails) {
                  <mat-icon>keyboard_arrow_up</mat-icon>
                }
              }
            </td>
          }
          <td class="user-cell date-col">{{ daySchedule.date | date }}</td>
          <td class="user-cell rest-hours-col padded">{{ daySchedule.restIn24HoursPeriod }}</td>
          <td class="user-cell rest-days-col">{{ daySchedule.restIn7DaysPeriod }}</td>
          @for (schedule of daySchedule.unitCompliances; track $index; let scheduleIndex = $index) {
            <td
              class="grid-cell-container"
              [ngClass]="{
                'colored-background': !embeddedView && scheduleIndex % 2 === 0,
              }"
            >
              <div
                (click)="onCellClick($event)"
                [ngClass]="getCellClasses(schedule, daySchedule, scheduleIndex)"
                [matTooltip]="
                  halfHoursInADay[scheduleIndex] +
                  (schedule.isBreach
                    ? !schedule.amountOfRestPeriodsCompliantInOneDay
                      ? ` • (${('amountOfRestPeriodsCompliantInOneDay' | translate)})`
                      : !schedule.hasAtLeastOneSixHoursRestPeriodInOneDay
                        ? ` • (${('hasAtLeastOneSixHoursRestPeriodInOneDay' | translate)})`
                        : !schedule.workHoursCompliantInSevenDays
                          ? ` • (${('workHoursCompliantInSevenDays' | translate)})`
                          : !schedule.workHoursCompliantInOneDay
                            ? ` • (${('workHoursCompliantInOneDay' | translate)})`
                            : ''
                    : schedule.unitComplianceColor === UserScheduleEntry.None
                      ? ''
                      : ` • ${(WORK_OVERVIEW_ENTRY_KEY[schedule.unitComplianceColor] | translate)}`)
                "
              ></div>
            </td>
          }
        </tr>
        @if (daySchedule.additionalInformation?.length) {
          <tr
            [ngClass]="{
              hidden: !daySchedule.showDetails,
            }"
          >
            <td colspan="51">
              <table class="descriptions-table">
                <thead>
                  <tr>
                    <th class="keyboard-arrow-col"></th>
                    <th class="fixed-col">{{ 'type' | translate }}</th>
                    <th class="fixed-col padded">{{ 'from' | translate }}</th>
                    <th class="fixed-col">{{ 'to' | translate | titlecase }}</th>
                    <th class="fixed-col">{{ 'totalAmountOfHours' | translate }}</th>
                    <th class="fixed-col">{{ 'description' | translate }}</th>
                    <th class="fixed-col">{{ 'comment' | translate }}</th>
                    <th class="fixed-col"></th>
                    <th class="fixed-col"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    description of daySchedule.additionalInformation;
                    track description;
                    let scheduleIndex = $index
                  ) {
                    <tr>
                      <td></td>
                      <td>
                        {{
                          description.isWork
                            ? ('manualWork' | translate)
                            : ('manualRest' | translate)
                        }}
                      </td>
                      <td>{{ description.from | timeDisplay }}</td>
                      <td>{{ description.to | timeDisplay }}</td>
                      <td>{{ description.totalAmountOfHours | numberRound }}</td>
                      <td>{{ description.description }}</td>
                      <td>{{ description.comment }}</td>
                      <td>
                        @if (
                          (description.approvalStatus === AdditionalTimeApprovalStatus.Pending &&
                            canUpdate) ||
                          canUpdateAfterAppoval
                        ) {
                          <button mat-button (click)="edit(description.id)">
                            <mat-icon>edit</mat-icon>
                          </button>
                        }
                      </td>
                      <td>
                        @if (
                          (description.approvalStatus === AdditionalTimeApprovalStatus.Pending &&
                            canDelete) ||
                          canDeleteAfterAppoval
                        ) {
                          <button mat-button (click)="remove(description.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
